import axiosInstance from "../api";
import { notification } from "antd";

// get Recommendations
export const getAllTravelRecommendations = async ({
  skip = 0,
  limit = 10,
  name = "",
} = {}) => {
  try {
    const params = new URLSearchParams();
    params.append("skip", skip);
    params.append("limit", limit);
    if (name) params.append("search", name);

    const response = await axiosInstance.get(
      `/traveler_type/all?${params.toString()}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Travel Recommendations",
      description:
        response?.data?.message || "Failed to fetch Travel Recommendations list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Travel recommendation",
      description:
        error.response?.data?.message || "Failed to fetch Travel recommendation list.",
      duration: 3,
    });
    throw new Error("Error fetching Travel recommendation list");
  }
};

// get user recommendations
export const getUsersTravelRecommendations = async (user_id) => {
  try {
    const response = await axiosInstance.get(
      `/traveler_type/users?user_id=${user_id}`
    );

    if (response?.data?.status_code === 200) {
      return response?.data?.data;
    }
    notification.error({
      message: "Error Fetching Travel Recommendations",
      description:
        response?.data?.message || "Failed to fetch Travel Recommendations list.",
      duration: 3,
    });
  } catch (error) {
    notification.error({
      message: "Error Fetching Travel recommendation",
      description:
        error.response?.data?.message || "Failed to fetch Travel recommendation list.",
      duration: 3,
    });
    throw new Error("Error fetching Travel recommendation list");
  }
};

export const createTravelRecommendation = async (travelRecommendationData) => {
  try {
    const formData = new FormData();
    formData.append("name", travelRecommendationData.name);
    formData.append("description", travelRecommendationData.description);
    if (travelRecommendationData.image) {
      formData.append("image", travelRecommendationData.image);
    }

    const response = await axiosInstance.post("/traveler_type/", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Creation Error",
        description:
          response.data.message ||
          "An error occurred while creating the Travel recommendation.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Creation Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error creating Travel recommendation"
    );
  }
};

export const updateTravelRecommendation = async (travelRecommendationData) => {
  try {
    const formData = new FormData();
    if (travelRecommendationData.name) {
      formData.append("name", travelRecommendationData.name);
    }
    if (travelRecommendationData.description) {
      formData.append("description", travelRecommendationData.description);
    }
    if (travelRecommendationData.image) {
      formData.append("image", travelRecommendationData.image);
    }
    if (travelRecommendationData.id) {
      formData.append("row_id", travelRecommendationData.id);
    }

    const response = await axiosInstance.put(
      `/traveler_type/update`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description:
          response.data.message ||
          "An error occurred while creating the travel recommendation.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description:
        error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(
      error.response?.data?.message || "Error creating travel recommendation"
    );
  }
};

export const activateDeactivateTravelRecommendation = async (updateId, active) => {
  try {
    const payload = { type_id : updateId, active: active}
    const response = await axiosInstance.put(`/traveler_type/activate_deactivate`, payload);

    if (response.data.status_code === 200) {
      notification.success({
        message: "Success",
        description: response.data.message,
        duration: 3,
      });
      return response.data.data;
    } else {
      notification.error({
        message: "Update Error",
        description: response.data.message || "An error occurred during update.",
        duration: 3,
      });
    }
  } catch (error) {
    notification.error({
      message: "Update Failed",
      description: error.response?.data?.message || "An unexpected error occurred.",
      duration: 3,
    });
    throw new Error(error.response?.data?.message || "Error");
  }
};

